const ajaxFilter = () => {
  const html = document.querySelectorAll('html')[0] ?? null
  const ajaxForm = document.getElementById('js-filters') ?? null
  const gridElm = document.getElementById('js-insights-grid') ?? null
  const detailsElm = document.querySelectorAll('details')
  const clearFilterBtn = document.getElementById('js-clear-filters') ?? null
  const searchInputs = document.querySelectorAll('.text-form') ?? null
  const spinner = document.getElementById('js-ajax-loader') ?? null

  if (!ajaxForm || !gridElm || !html) return

  window.onload = () => ajaxForm.reset()

  const generateURL = (form) => {
    const formData = new FormData(form)
    const queryString = new URLSearchParams(formData).toString()
    const url = `${window.location.origin}${window.location.pathname}?${queryString}&ajax=true`
    // history.pushState(null, null, newUrl)
    return url
  }

  const ajaxFunc = async (e) => {
    e.preventDefault()

    const queryString = e.target.classList.contains('js-page-btn')
      ? e.target.href
      : generateURL(ajaxForm)

    if (e.target.type == 'checkbox') {
      const detailElm = e.target.closest('details')
      const title = detailElm.querySelectorAll('summary span')[0]
      const checkboxes = detailElm.querySelectorAll(
        "input[type='checkbox']:checked",
      )

      if (checkboxes.length !== 0) {
        title.innerHTML = `${title.dataset.title} (${checkboxes.length})`
        title.dataset.text = `${title.dataset.title} (${checkboxes.length})`
      } else {
        title.innerHTML = title.dataset.title
      }

      const hasCheckboxes = ajaxForm.querySelectorAll(
        "input[type='checkbox']:checked",
      )

      hasCheckboxes.length !== 0
        ? clearFilterBtn.classList.remove('hidden')
        : clearFilterBtn.classList.add('hidden')
    }

    if (controller) controller.abort()

    const controller = new AbortController()
    const signal = controller.signal

    try {
      spinner.classList.remove('invisible')

      const markup = await fetch(queryString, {
        method: 'GET',
        singal: signal,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      }).then(function (response) {
        return response.text()
      })

      if (markup && gridElm) {
        gridElm.innerHTML = markup

        spinner.classList.add('invisible')

        if (e.target.classList.contains('js-page-btn')) html.scrollTop = 0
      }
    } catch (err) {
      console.log('Aborted:', err)
    }
  }

  // Submit on Form Change
  ajaxForm.addEventListener('change', ajaxFunc)

  // Prevent Enter on Form
  ajaxForm.addEventListener('keydown', (e) => {
    if (e.key == 'Enter') {
      e.preventDefault()
      return false
    }
  })

  // Search & Clear Form
  searchInputs &&
    searchInputs.forEach((searchInput) => {
      const resetInputs = searchInput.querySelectorAll("input[type='reset'")

      resetInputs.forEach((resetInput) => {
        resetInput.addEventListener('click', (e) => {
          e.preventDefault()
          e.target.previousElementSibling.value = ''
          resetInput.disabled = true

          if (e.target.classList.contains('ajax')) ajaxFunc(e)
        })
      })

      searchInput.addEventListener('keyup', (e) => {
        const reset = e.target.nextElementSibling ?? null

        if (!reset) return

        !e.target.value ? (reset.disabled = true) : (reset.disabled = false)

        if (searchInput.classList.contains('ajax')) ajaxFunc(e)
      })
    })

  // Next & Last Page
  gridElm.addEventListener('click', (e) => {
    if (
      e.target.classList.contains('js-page-btn') &&
      !e.target.getAttribute('aria-disabled')
    )
      ajaxFunc(e)
  })

  // Close Details Tag
  detailsElm &&
    html.addEventListener('click', (e) => {
      const isInsideDetails = e.target.closest('details')

      if (isInsideDetails && e.target.tagName !== 'SUMMARY') return

      detailsElm.forEach((detailElm) => {
        if (e.target.parentNode.id !== detailElm.id) {
          detailElm.removeAttribute('open')
        }
      })
    })
}

export default ajaxFilter
